import React from 'react';
import PropTypes from 'prop-types';
import TextButton from '@spothero/ui/text-button';

/* eslint-disable camelcase */
export const inOutMessages = {
    no: () => "In/Out NOT allowed. Once you leave, that's it, my friend.",
    yes_fee: inOut => `There is a $${inOut.fee} charge for each in/out.`,
    yes_limited: inOut =>
        `In/outs are limited to ${inOut.limit} per ${inOut.limit_type}.`,
    yes_limited_fee: inOut =>
        `In/outs are limited to ${inOut.limit} per ${inOut.limit_type}. Additional in/outs are allowed for a $${inOut.fee} fee.`,
};

const parkingPassMessages = {
    self_park_see_attendant:
        'You will display your parking pass park at this facility.',
    scan_in_out: 'You will scan your parking pass park at this facility.',
    hang: 'You will receive a hang tag to park at this facility.',
    license_plate:
        'Your license plate number will allow you to park at this facility.',
    access_card: 'You will receive an access pass to park at this facility.',
    sticker: 'You will receive a sticker to park at this facility.',
};
/* eslint-enable camelcase */

const ThingsYouShouldKnowMonthly = ({
    isNewMonthlyRate,
    heightRestrictionDescription,
    contractRequired,
    inOut,
    parkingPassType,
    rateDescription,
    onShowRateDetailsClick,
}) => {
    const onImportantDetailsClicked = () => {
        onShowRateDetailsClick('contract');
    };

    return (
        <div className="SpotDetails-section ThingsYouShouldKnow">
            <h4 className="subtitle">Things You Should Know</h4>
            {isNewMonthlyRate && (
                <ul className="ThingsYouShouldKnow-list">
                    {heightRestrictionDescription && (
                        <li className="ThingsYouShouldKnow-list-item">
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: heightRestrictionDescription,
                                }}
                            />
                        </li>
                    )}
                    {contractRequired && (
                        <li className="ThingsYouShouldKnow-list-item">
                            Contract Required.
                            <TextButton
                                data-section="contract"
                                onClick={onImportantDetailsClicked}
                            >
                                Important Details
                            </TextButton>
                            .
                        </li>
                    )}
                    {inOut && inOutMessages[inOut.allowed] && (
                        <li className="ThingsYouShouldKnow-list-item">
                            {inOutMessages[inOut.allowed](inOut)}
                        </li>
                    )}
                    {parkingPassType && (
                        <li className="ThingsYouShouldKnow-list-item">
                            {parkingPassMessages[parkingPassType]}
                        </li>
                    )}
                </ul>
            )}
            {rateDescription && (
                <div
                    className="OtherDescription"
                    dangerouslySetInnerHTML={{__html: rateDescription}}
                />
            )}
        </div>
    );
};

ThingsYouShouldKnowMonthly.propTypes = {
    isNewMonthlyRate: PropTypes.bool,
    heightRestrictionDescription: PropTypes.string,
    contractRequired: PropTypes.bool,
    inOut: PropTypes.shape({
        allowed: PropTypes.string,
        fee: PropTypes.number,
        limit: PropTypes.number,
        limit_type: PropTypes.string, // eslint-disable-line camelcase
    }),
    parkingPassType: PropTypes.string,
    rateDescription: PropTypes.string,
    onShowRateDetailsClick: PropTypes.func.isRequired,
};

export default ThingsYouShouldKnowMonthly;
